import * as ACTION_TYPES from "./Main_types";

export const LOGIN_SUCCESS = ({
  agency,
  phoneVerified,
  userType,
  questionnaire,
  sentimentQuestionnaire,
  agencyLinked,
}) => {
  return {
    type: ACTION_TYPES.LOGIN_SUCCESS,
    agency: agency,
    phoneVerified: phoneVerified,
    userType: userType,
    questionnaire: questionnaire,
    sentimentQuestionnaire: sentimentQuestionnaire,
    agencyLinked: agencyLinked,
  };
};

export const LOGIN_FAILURE = (error) => {
  return {
    type: ACTION_TYPES.LOGIN_FAILURE,
    payload: error,
  };
};

export const LOGOUT = () => {
  return {
    type: ACTION_TYPES.LOGOUT,
  };
};

export const ACCEPT_DISCLOSURES = () => {
  return {
    type: ACTION_TYPES.ACCEPT_DISCLOSURES,
  };
};

export const PHONE_VERIFIED = () => {
  return {
    type: ACTION_TYPES.PHONE_VERIFIED,
  };
};

export const QUESTIONNAIRE = () => {
  return {
    type: ACTION_TYPES.QUESTIONNAIRE,
  };
};

export const SENTIMENT_QUESTIONNAIRE = () => {
  return {
    type: ACTION_TYPES.SENTIMENT_QUESTIONNAIRE,
  };
};

export const AGENCY_LINKED = () => {
  return {
    type: ACTION_TYPES.AGENCY_LINKED,
  };
};

export const SET_PROFILE = (profile) => {
  return {
    type: ACTION_TYPES.SET_PROFILE,
    payload: profile,
  };
};

export const SET_ACCOUNTS = (accounts) => {
  return {
    type: ACTION_TYPES.SET_ACCOUNTS,
    payload: accounts,
  };
};

export const SET_AVATAR = (base64) => {
  return {
    type: ACTION_TYPES.SET_AVATAR,
    payload: base64,
  };
};

export const SET_REFCODE = (code) => {
  return {
    type: ACTION_TYPES.SET_REFCODE,
    payload: code,
  };
};

export const SET_APPCONFIG = (cfg) => {
  return {
    type: ACTION_TYPES.SET_APPCONFIG,
    payload: cfg,
  };
};

export const SET_AGENCY_DETAILS = (code) => {
  return {
    type: ACTION_TYPES.SET_AGENCY_DETAILS,
    payload: code,
  };
};
